// extracted by mini-css-extract-plugin
export default {"headerBar":"zJ-z","pointsSection":"AJ-z","goToDashboard":"BJ-z"};